module.exports = __webpack_public_path__ + "static/media/example2.abfa1ee7.jpg";